import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import { useStatsig } from '../../hooks/useStatsig';
import HotelPlannerBanner from '../HotelPlannerCard';
import TennisPassportBanner from './TennisPassportBanner';
import MarketingBanner from './MarketingBanner';
import ExclusiveAccessBanner from './ExclusiveAccessBanner';

const variantMap = {
    control: HotelPlannerBanner,
    tennis_passport: TennisPassportBanner,
    marketing: MarketingBanner,
    exclusive_access: ExclusiveAccessBanner,
};

const GlobalPrivilegesBanner = ({ surface = PowerFunnelSurfaces.HOME }) => {
    const auth = useSelector(({ auth }) => auth);
    const { getExperiment, experiments } = useStatsig();
    const { user } = auth;
    const variantParameter = 'ui_variant';
    const isAnnualSubscription = user?.isPowered && user?.subscriptionTierType === 'year';

    // Annual subscribers are excluded from the experiment — always show control
    let variant = 'control';
    if (!isAnnualSubscription) {
        const experiment = getExperiment(experiments.GLOBAL_PRIVILEGES_MODULE);
        variant = experiment.get(variantParameter, 'control');
    }

    const VariantComponent = variantMap[variant] || HotelPlannerBanner;
    return <VariantComponent surface={surface} variant={variant} />;
};

GlobalPrivilegesBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
};

GlobalPrivilegesBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
};

export default GlobalPrivilegesBanner;
